import { render, staticRenderFns } from "./fireworksAdmin.vue?vue&type=template&id=6ca2b842&scoped=true"
import script from "./fireworksAdmin.vue?vue&type=script&lang=js"
export * from "./fireworksAdmin.vue?vue&type=script&lang=js"
import style0 from "./fireworksAdmin.vue?vue&type=style&index=0&id=6ca2b842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2b842",
  null
  
)

export default component.exports